// @ts-nocheck
import React, {useCallback, useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';
import {useHistory, Redirect} from 'react-router-dom';
import './CartPage.less';

import {Layout} from 'new-components/layout/Layout';
import {CartMap} from 'compositions/cart-map/CartMap';
import {Button} from 'elements/button/Button';
import {BackButton} from 'elements/back-button/BackButton';
import {OrderDetails} from 'compositions/order-details/OrderDetails';
import {PaymentDetails} from 'compositions/payment-details/PaymentDetails';
import {CartDisplay} from 'compositions/cart-display/CartDisplay';
import {changeOrderLineModifiers, decOrderLineQuantity, incOrderLineQuantity} from "new-actions/order-line.actions.ts";
import {getCartTotal} from "helpers/purchase.helper.ts";
import {DialogManager} from "dialog-layout/dialog-manager/DialogManager";
import {PickupTime} from "new-components/popups/pickup-time/PickupTime";
import {setPickerDate, setPickupDateTime} from "new-actions/order-time.actions";
import {getDateFormattedForPickup, getTimeFormattedForPickup} from "helpers/order-time.helper";
import {OrderComment} from "new-components/popups/order-comment/OrderComment";
import {
	decCutlery,
	incCutlery,
	placeOrder,
	setOrderComment,
	setPaymentType,
	setTipPercent,
	setUseCashPoints
} from "new-actions/purchase.actions";
import {DeliveryAddress} from "new-components/popups/delivery-address/DeliveryAddress";
import {CashPointsDefaultName, OrderingTypes, PaymentTypes, RestaurantTypes} from "new-constants/common.constants";
import {Card} from "elements/card/Card.tsx";
import {Block} from "compositions/block/Block.tsx";
import {DialogStack} from "dialog-layout/dialog-stack/DialogStack";
import {
	STRIPE_CARD_REGISTRATION_POPUP,
	StripeCardRegistration
} from "new-components/popups/stripe-card-registration/StripeCardRegistration";
import {
	cancelCardPaymentWarningMessage,
	cancelCartModifierGroupEdit,
	cancelDiscountErrorMessage,
	cancelPickupWarningMessage,
	cancelPromocode,
	cancelSendOrderErrorMessage,
	cancelStripeCardRegistration,
	cancelTableEdit,
	cancelVippsErrorMessage,
	cancelVippsPaymentFrame,
	doneCardPaymentWarningMessage,
	donePickupWarningMessage,
	donePromocode,
	doneTableEdit,
	openCartModifierGroupEdit,
	openPromocode,
	openTableEdit,
	cancelGooglePayInitErrorMessage,
	cancelApplePayPopup,
	cancelApplePayInitErrorMessage,
	cancelStripeThreeDs, openGuestOrderPopup, openConfirmGuestOrderPopup, cancelConfirmGuestOrderPopup
} from "new-actions/popup.actions";
import {stripeError, stripeSuccess, vippsError, vippsSuccess, mobilePayRedirect} from "new-actions/payment.actions";
import {
	getAvailablePaymentTypesSelector,
	getCartItemsSelector,
	getCurrentCustomerSelector, getCurrentDeliveryAddressSelector, getCurrentFilteredRestaurantListSelector,
	getCurrentMenuSelector,
	getCurrentPaymentTypeSelector,
	getCurrentPromocodeSelector,
	getCurrentPurchaseSelector,
	getCurrentRestaurantIdSelector,
	getCurrentRestaurantSelector, getCurrentServerPopupsSelector,
	getCurrentServerValuesSelector, getCurrentSubPaymentTypeSelector,
	getCurrentTableNumberSelector, getCurrentTemporaryOrderIdSelector,
	getDeliveryConditionsSelector,
	getSubPaymentTypesSelector,
	getTipAmountSelector,
	getTranslationsSelector,
	isGiveTipsSelector,
	getCurrentServerConfig, getCurrentGuestSelector
} from "../../../selectors";
import {
	APPLY_PROMOCODE, DISCOUNT,
	RESTAURANT_LIST_BY_ZIP,
	SEND_ORDER,
	SET_TABLE, SUBMIT_APPLE_PAY, SUBMIT_GOOGLE_PAY
} from "new-constants/api.constants";
import {getCartDiscount} from "helpers/order-line.helper.ts";
import {PROMOCODE_EDIT_POPUP, PromocodeEdit} from "new-components/popups/promocode-edit/PromocodeEdit";
import {TABLE_EDIT_POPUP, TableEdit} from "new-components/popups/table-edit/TableEdit";
import {
	VIPPS_PAYMENT_FRAME_POPUP,
	VippsPaymentFrame
} from "new-components/popups/vipps-payment-frame/VippsPaymentFrame";
import {
	APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP,
	DISCOUNT_ERROR_MESSAGE_POPUP,
	ErrorMessage,
	GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP,
	SEND_ORDER_ERROR_MESSAGE_POPUP,
	VIPPS_ERROR_MESSAGE_POPUP
} from "new-components/popups/error-message/ErrorMessage";
import {VIPPS_ERROR} from "new-constants/payment.constants";
import {
	CART_MODIFIER_GROUP_EDIT_POPUP,
	ModifierGroupEdit
} from "new-components/popups/modifier-group-edit/ModifierGroupEdit";
import {Offline} from "new-components/popups/offline/Offline";
import {
	CARD_PAYMENT_CONFIRMATION_POPUP,
	Confirmation,
	PICKUP_CONFIRMATION_POPUP
} from "new-components/popups/confirmation/Confirmation";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";
import {PageHeader} from "compositions/page-header/PageHeader";
import {getMenuEntry, hasAlcoholEntry} from "helpers/menu.helper";
import {CUSTOM_PAYMENT_TYPE_CONFIRMATION_POPUP} from "../../popups/confirmation/Confirmation";
import {
	cancelZipEditFromCart,
	cancelCustomPaymentTypeWarningMessage,
	cancelRepeatOrderMessageFromCart,
	cancelSelectLocationFromCart,
	doneZipEditFromCart,
	doneCustomPaymentTypeWarningMessage,
	doneServerPopup,
	openLocationPermissionConfirmation,
	openDeliveryAddressFromCart,
	cancelDeliveryAddressFromCart,
	doneDeliveryAddressFromCart,
	cancelMobilePayInitErrorMessage,
	cancelAdyenCardRegistration,
	cancelAdyenCardCheckPaymentErrorMessagePopup,
	cancelSwishPay,
	cancelSwishPayInitErrorMessage,
	doneSlowServiceCaption,
	cancelGooglePayPopup
} from "../../../actions/popup.actions";
import {roundedUpTip} from "../../../helpers/purchase.helper";
import {ServerPopupContainer} from "../../popups/server-popup/ServerPopup.container";
import {openExternalLink, openMenuEntryLink, openRestaurantLink} from "../../../actions/link.actions";
import {CART_ZIP_EDIT_POPUP, ZipEdit} from "../../popups/zip-edit/ZipEdit";
import {
	CART_SELECT_LOCATION_POPUP,
	SelectLocation
} from "../../popups/select-location/SelectLocation";
import {isPossibleToRequestLocationPermission} from "../../../helpers/permission.helper";
import {setCurrentRestaurantFromCart} from "../../../actions/app-state.actions";
import {
	CHECK_ADYEN_PAYMENT,
	INIT_ADYEN_PAYMENT,
	ORDER_DATES,
	ORDER_TIME_SLOTS,
	REGISTER_ADYEN_CARD,
	REPEAT_ORDER
} from "../../../constants/api.constants";
import {CART_DELIVERY_ADDRESS_POPUP} from "../../popups/delivery-address/DeliveryAddress";
import {CardStyles} from "../../elements/card/Card";
import {EmptyPlaceholder} from "../../elements/empty-placeholder/EmptyPlaceholder";
import useOnScreen from "../../../hooks/on-screen.hook";
import {ScrolldownButton} from "../../elements/scrolldown-button/ScrolldownButton";
import {CartDisclaimer} from "../../compositions/cart-disclaimer/CartDisclaimer";
import {MOBILE_PAY_FORM_POPUP, MobilePayForm} from "../../popups/mobile-pay-form/MobilePayForm";
import {
	initSwishPayment,
	mobilePaySubmit,
	submitAdyenCardAdditionalDetails,
	submitAdyenCardRegister,
	submitSwishPaymentAdditionalDetails,
	initGooglePayPayment,
	initApplePayPayment
} from "../../../actions/payment.actions";
import {getRestaurantRoute} from "../../../helpers/routes.helper";
import {LoadingSpinner} from "../../elements/loading-spinner/LoadingSpinner";
import {
	ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP,
	MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP,
	SWISH_PAYMENT_ERROR_MESSAGE_POPUP
} from "../../popups/error-message/ErrorMessage";
import {trackEvent} from "../../../helpers/tracking.helpers";
import {AdyenCardRegistration} from "../../popups/adyen-card-registration/AdyenCardRegistration";
import {
	ADYEN_APPLE_PAY_POPUP,
	ADYEN_CARD_REGISTRATION_POPUP,
	ADYEN_GOOGLE_PAY_POPUP, CONFIRM_GUEST_ORDER_POPUP,
	SLOW_SERVICE_POPUP, STRIPE_THREE_DS_POPUP,
	SWISH_PAY_POPUP
} from "../../../constants/popup.constants";
import {SwishPay} from "../../popups/swish-pay/SwishPay";
import { setInfoMessage } from "../../../managers/client-log.manager";
import {AdyenGooglePay} from "../../popups/adyen-google-pay/AdyenGooglePay";
import {AdyenApplePay} from "../../popups/adyen-apple-pay/AdyenApplePay";
import {StripeThreeDs} from "new-components/popups/stripe-three-ds/StripeThreeDs";
import ReactPixel from "react-facebook-pixel";
import {ConfirmGuestOrderPopup} from "new-components/popups/confirm-guest-order/ConfirmGuestOrderPopup";


const CartPage = ({
	currentPurchase,
	currentRestaurantId,
	cartItems,
	orderingMode,
	orderTime,
	translations,
	availablePaymentTypes,
	subPaymentTypes,
	currentPaymentType,
	currentSubPaymentType,
	currentRestaurant,
	popup,
	payment,
	currentServerValues,
	fetchProgress,
	fetchError,
	currentDeliveryAddress,
	deliveryConditions,
	currentPromocode,
	currentTableNumber,
	currentMenu,
	currentCustomer,
	connectivity,
	isGiveTips,
	tipAmount,
	currentServerPopups,
	currentTemporaryOrderId,
	currentFilteredRestaurantList,
	permission,
	fetchMessage,
	loading,
	currentServerConfig,
	currentGuest,

	incOrderLineQuantity,
	decOrderLineQuantity,
	setPickerDate,
	setPickupDateTime,
	setOrderComment,
	setTipPercent,
	setPaymentType,
	setUseCashPoints,
	placeOrder,
	cancelStripeCardRegistration,
	stripeSuccess,
	stripeError,
	openPromocode,
	cancelPromocode,
	donePromocode,
	openTableEdit,
	cancelTableEdit,
	doneTableEdit,
	cancelVippsPaymentFrame,
	vippsSuccess,
	vippsError,
	cancelVippsErrorMessage,
	cancelDiscountErrorMessage,
	openCartModifierGroupEdit,
	cancelCartModifierGroupEdit,
	changeOrderLineModifiers,
	cancelPickupWarningMessage,
	donePickupWarningMessage,
	cancelCardPaymentWarningMessage,
	doneCardPaymentWarningMessage,
	incCutlery,
	decCutlery,
	cancelSendOrderErrorMessage,
	cancelCustomPaymentTypeWarningMessage,
	doneCustomPaymentTypeWarningMessage,
	doneServer,
	openExternalLink,
	openRestaurantLink,
	openMenuEntryLink,
	cancelZipEditFromCart,
	doneZipEditFromCart,
	openLocationPermissionConfirmation,
	setCurrentRestaurantFromCart,
	cancelSelectLocationFromCart,
	cancelRepeatOrderMessageFromCart,
	openDeliveryAddressFromCart,
	cancelDeliveryAddressFromCart,
	doneDeliveryAddressFromCart,
	mobilePaySubmit,
	mobilePayRedirect,
	cancelMobilePayInitErrorMessage,
	cancelAdyenCardRegistration,
	submitAdyenCardRegister,
	submitAdyenCardAdditionalDetails,
	cancelAdyenCardCheckPaymentErrorMessagePopup,
	initSwishPayment,
	submitSwishPaymentAdditionalDetails,
	cancelSwishPay,
	cancelSwishPayInitErrorMessage,
	doneSlowServiceCaption,
	cancelGooglePayPopup,
	initGooglePayPayment,
	cancelGooglePayInitErrorMessage,
	cancelApplePayPopup,
	cancelApplePayInitErrorMessage,
	initApplePayPayment,
	cancelStripeThreeDs,
	vippsCheckPaymentPolling,
	openConfirmGuestOrderPopup,
	cancelConfirmGuestOrderPopup,
}) => {

	const history = useHistory();
	//TODO rewrite to new popups
	const [isPickupTimePopupOpen, setPickupTimePopupOpen] = useState(false);
	const [isCommentPopupOpen, setCommentPopupOpen] = useState(false);

	const [showServerPopup, setShowServerPopup] = useState(true);

	// todo: remove this comment
	useEffect(() => {
		setShowServerPopup(true);
	}, [currentRestaurantId]);

	const orderButtonRef = useRef(null);
	const isOrderButtonVisible = useOnScreen(orderButtonRef);

	const [editableCartModifierGroupId, setEditableCartModifierGroupId] = useState(null);
	const [editableCartItemToken, setEditableCartItemToken] = useState(null);
	const editableCartItem = editableCartItemToken && cartItems.find(cartItem => cartItem.token === editableCartItemToken);
	const editableCartItemMenuEntry = editableCartItem && getMenuEntry(currentMenu.menu.menu, editableCartItem.menuEntryId);
	const editableCartModifierGroup = editableCartModifierGroupId && currentMenu.menu.modifierGroups.find(
		modifierGroup => modifierGroup.modifierGroupId === editableCartModifierGroupId);
	const cartContainsAlcoholEntry = hasAlcoholEntry(currentMenu.menu.menu, cartItems);

	const onTimeClick = useCallback(() => setPickupTimePopupOpen(true), []);
	const onCommentClick = useCallback(() => setCommentPopupOpen(true), []);

	const onCashpointsClick = useCallback(useCashPoints => setUseCashPoints(currentRestaurantId, useCashPoints), [currentRestaurantId]);
	const onTipPercentClick = useCallback(percent => setTipPercent(currentRestaurantId, percent), [currentRestaurantId]);
	const onRoundTipClick = useCallback(
		(percent) => {
			setTipPercent(currentRestaurantId, percent)
		},
		[currentRestaurantId]);
	const onCutleryIncClick = useCallback(() => incCutlery(currentRestaurantId), [currentRestaurantId]);
	const onCutleryDecClick = useCallback(() => decCutlery(currentRestaurantId), [currentRestaurantId]);

	const onQuantityDecClick = useCallback(token => decOrderLineQuantity(currentRestaurantId, token), [currentRestaurantId]);
	const onQuantityIncClick = useCallback(token => incOrderLineQuantity(currentRestaurantId, token), [currentRestaurantId]);
	const onModifierGroupClick = useCallback((modifierGroupId, token) => {
		setEditableCartModifierGroupId(modifierGroupId);
		setEditableCartItemToken(token);
		openCartModifierGroupEdit();
	}, []);

	const closeCartModifierGroupEdit = () => {
		cancelCartModifierGroupEdit();
		setEditableCartModifierGroupId(null);
		setEditableCartItemToken(null);
	}

	const openNextCartModifierGroupEdit = () => {
		const nextModifierGroupIdIndex = editableCartItemMenuEntry.modIds.indexOf(editableCartModifierGroupId) + 1;
		setEditableCartModifierGroupId(editableCartItemMenuEntry.modIds[nextModifierGroupIdIndex]);
	}

	const executeScroll = () => orderButtonRef.current.scrollIntoView();

	useEffect(() => {
		if(!currentServerConfig?.googleTagManagerId || cartItems.length <= 0) {
			return;
		}

	 	window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('event', 'initiate_checkout', {
			cart_item_count: cartItems?.length || 0,
			value: totalPrice
		});
	}, [currentServerConfig]);

	useEffect(() => {
		if(!currentServerConfig?.facebookPixelId || cartItems.length <= 0) {
			return;
		}

		ReactPixel.trackCustom('initiate_checkout', {
			cart_item_count: cartItems?.length || 0,
			value: totalPrice
		});
	}, [currentServerConfig]);

	const onPlaceOrder = () => {
		placeOrder(
			false,
			currentPaymentType,
			currentCustomer?.cardNumber,
			currentRestaurant.restaurantType !== RestaurantTypes.TABLE_SERVING ? false : !currentTableNumber,
			currentRestaurantId,
		);
	}


	if (!orderingMode.orderingType) {
		return <Redirect to={getRestaurantRoute()}/>;
	}

	if (cartItems.length <= 0) {
		return (<TranslationsContext.Provider value={translations}>
			<Layout>
				<div className="cart-page">
					<div className="cart-page__back">
						<BackButton onClick={() => {
							trackEvent({
								event: 'Navigate From Cart To Restaurant',
								properties: {
									'Venue Id': currentRestaurantId,
								}
							});
							history.goBack()
						}
						}/>
					</div>
					<div className="cart-page__header">
						<PageHeader
							title={getSafeTranslation('CartPage.headerTitle', translations)}
						/>
					</div>
					<div className="cart-page__empty-placeholder">
						<Card style={CardStyles.NESTED}>
							<EmptyPlaceholder text={getSafeTranslation('CartPage.emptyPlaceholder', translations)}/>
						</Card>
					</div>
				</div>
				<DialogManager>
					<DialogStack>
						{
							fetchMessage[REPEAT_ORDER] && fetchMessage[REPEAT_ORDER].length > 0 && (<ErrorMessage
								description={fetchMessage[REPEAT_ORDER].join('')}
								onOverlayClick={cancelRepeatOrderMessageFromCart}
								control={<Button isAutoWidth
																 onClick={cancelRepeatOrderMessageFromCart}>
									{getSafeTranslation('RepeatOrderMessage.buttonCaption', translations)}
								</Button>}
							/>)
						}
						{
							popup.includes(DISCOUNT_ERROR_MESSAGE_POPUP) && (
								<ErrorMessage
									title={getSafeTranslation('DiscountErrorMessagePopup.title', translations)}
									description={fetchError[DISCOUNT]}
									onOverlayClick={cancelDiscountErrorMessage}
									control={<Button isAutoWidth onClick={cancelDiscountErrorMessage}>
										{getSafeTranslation('DiscountErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							)
						}
					</DialogStack>
				</DialogManager>
			</Layout>
		</TranslationsContext.Provider>)
	}

	const totalPrice = getCartTotal(currentPurchase, currentServerValues, deliveryConditions, cartItems, 0);

	const roundUpPercent = Math.abs(((roundedUpTip(totalPrice) - totalPrice)) / totalPrice) * 100;

	//TODO do not show order extras in ExpressKiosk

	if (!currentRestaurant?.restaurantType) {
		setInfoMessage(`Cart Page for qtf-2216:
		currentRestaurant: ${JSON.stringify(currentRestaurant)}
	`);
	}


	return (
		<TranslationsContext.Provider value={translations}>
			<Layout>
				<div className="cart-page">
					<div className="cart-page__map">
						<CartMap
							latitude={currentDeliveryAddress?.latitude || currentRestaurant.latitude}
							longitude={currentDeliveryAddress?.longitude || currentRestaurant.longitude}
							address={currentDeliveryAddress?.address || currentRestaurant.address}
							zip={currentDeliveryAddress?.zip || currentRestaurant.zipCode}
						/>
					</div>
					<div className="cart-page__back">
						<BackButton onClick={() => history.goBack()}/>
					</div>
					<div className="cart-page__header">
						<PageHeader
							title={getSafeTranslation('CartPage.headerTitle', translations)}
						/>
					</div>
					<div className="cart-page__order-details">
						<Block title={getSafeTranslation('CartPage.orderDetailsBlockTitle', translations)}>
							<Card isNoPaddings>
								<OrderDetails
									pickupLocation={currentRestaurant.name}
									isShowTableNumber={currentRestaurant.restaurantType === RestaurantTypes.TABLE_SERVING}
									tableNumber={currentTableNumber}
									onTableNumberClick={openTableEdit}
									isShowPickupTime={
										currentRestaurant.possibleToGivePickupTime
									}
									pickupTime={
										orderTime.pickupDate && orderTime.pickupTime && `${
											getDateFormattedForPickup(orderTime.pickupDate, translations, orderTime.todayDate)
										}, ${
											getTimeFormattedForPickup(orderTime.pickupTime, orderTime.asap && orderTime.asap.waitMinutes, translations)
										}`}
									orderingType={orderingMode?.orderingType}
									onTimeClick={onTimeClick}
									isShowAddress={orderingMode?.orderingType === OrderingTypes.delivery}
									pickupAddress={currentDeliveryAddress?.address}
									onAddressClick={openDeliveryAddressFromCart}
									isShowComment={currentRestaurant.isMessageWithOrder}
									comment={currentPurchase?.comment}
									restaurantDeliveryLabel={currentRestaurant.deliveryLabel}
									onCommentClick={onCommentClick}
									isShowCutlery={currentRestaurant?.isAskNumberOfPeople}
									cutlery={currentPurchase?.cutlery}
									onCutleryIncClick={onCutleryIncClick}
									onCutleryDecClick={onCutleryDecClick}
								/>
							</Card>
						</Block>
					</div>
					<div className="cart-page__payment">
						<Block title={getSafeTranslation('CartPage.paymentBlockTitle', translations)}>
							<Card isNoPaddings>
								<PaymentDetails
									selectedPaymentType={currentPaymentType}
									selectedSubPaymentType={currentSubPaymentType}
									paymentTypes={availablePaymentTypes}
									subPaymentTypes={subPaymentTypes}
									cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
									useCashPoints={currentPurchase.useCashPoints}
									availableCashpoints={currentServerValues.cashpointsAmount}
									onCashpointsClick={onCashpointsClick}
									isShowTips={isGiveTips}
									tipPercent={currentPurchase?.tipPercent}
									onTipPercentClick={onTipPercentClick}
									isShowPromocode={currentRestaurant?.isPromotionCodesInApp}
									promocodes={currentPromocode}
									onPromocodeClick={openPromocode}
									onRoundTipClick={onRoundTipClick}
									roundUpTip={roundedUpTip(totalPrice)}
									roundUpPercent={roundUpPercent}
									onPaymentTypeClick={(paymentType, subPaymentType) => {
										setPaymentType(currentRestaurantId, paymentType, subPaymentType);
									}}
								/>
							</Card>
						</Block>
					</div>
					<div className="cart-page__items">
						<Block
							title={getSafeTranslation('CartPage.itemsBlockTitle', translations)}
							subTitleControl={cartContainsAlcoholEntry ?
								<CartDisclaimer text={getSafeTranslation('CartPage.alcoholDisclaimer', translations)}/> : null}
						>
							<Card isNoPaddings>
								<CartDisplay
									cartItems={cartItems}
									onQuantityDecClick={onQuantityDecClick}
									onQuantityIncClick={onQuantityIncClick}
									onModifierGroupClick={onModifierGroupClick}
									discount={getCartDiscount(cartItems, deliveryConditions, currentServerValues)}
									delivery={
										orderingMode?.orderingType === OrderingTypes.delivery && (deliveryConditions?.price || currentRestaurant.deliveryPrice || 0)
									}
									cashpoints={currentPurchase.useCashPoints && currentServerValues.cashpointsAmount}
									cashpointsName={(currentRestaurant?.cashPointsName) || CashPointsDefaultName}
									tip={tipAmount}
									total={getCartTotal(currentPurchase, currentServerValues, deliveryConditions, cartItems, tipAmount)}
									isHighlightTotal
								/>
							</Card>
						</Block>
					</div>
					<div ref={orderButtonRef} className="cart-page__place">
						<Button
							onClick={onPlaceOrder}
							isDisabled={fetchProgress[SEND_ORDER]}
						>
							{getSafeTranslation('CartPage.placeOrderButtonCaption', translations)}
						</Button>
					</div>
					{
						!isOrderButtonVisible &&
						<div className="cart-page__floating-button"><ScrolldownButton onClick={() => executeScroll()}/></div>
					}
					<DialogManager>
						<DialogStack>
							{
								popup.includes(PICKUP_CONFIRMATION_POPUP) && (
									<Confirmation
										title={getSafeTranslation('PickupConfirmationPopup.title', translations)}
										description={getSafeTranslation('PickupConfirmationPopup.description', translations).replace('{phone}', currentCustomer.phone || currentGuest?.phone)}
										onOverlayClick={cancelPickupWarningMessage}
										onYesClick={donePickupWarningMessage}
										onNoClick={cancelPickupWarningMessage}
									/>
								)
							}
							{
								popup.includes(CARD_PAYMENT_CONFIRMATION_POPUP) && (
									<Confirmation
										title={getSafeTranslation('CardPaymentConfirmationPopup.title', translations)}
										description={getSafeTranslation('CardPaymentConfirmationPopup.description', translations).replace('{cardNumber}',
											currentCustomer?.cardNumber)}
										onOverlayClick={() => cancelCardPaymentWarningMessage(currentRestaurantId)}
										onYesClick={() => doneCardPaymentWarningMessage(currentRestaurantId)}
										onNoClick={() => cancelCardPaymentWarningMessage(currentRestaurantId)}
									/>
								)
							}
							{
								isPickupTimePopupOpen && (
									<PickupTime
										orderingMode={orderingMode}
										orderTime={orderTime}
										isFutureOrdersAllowed={currentRestaurant?.isFutureOrdersAllowed}
										error={
											`${fetchMessage[ORDER_DATES] || ''}\n
												${fetchError[ORDER_DATES] || ''}\n
										 		${fetchMessage[ORDER_TIME_SLOTS] || ''}\n
										 		${fetchError[ORDER_TIME_SLOTS] || ''}`
										}
										onDateClick={date => setPickerDate(date)}
										onOverlayClick={() => setPickupTimePopupOpen(false)}
										onCancelClick={() => setPickupTimePopupOpen(false)}
										onDoneClick={(date, time) => {
											setPickupTimePopupOpen(false);
											setPickupDateTime(date, time);
										}}
									/>
								)
							}
							{
								isCommentPopupOpen && (<OrderComment
									defaultValue={currentPurchase?.comment}
									maxLength={currentRestaurant?.restrictions?.messageLength}
									onCancelClick={() => setCommentPopupOpen(false)}
									onOverlayClick={() => setCommentPopupOpen(false)}
									onDoneClick={comment => {
										setCommentPopupOpen(false);
										setOrderComment(currentRestaurantId, comment);
									}}
								/>)
							}
							{popup.includes(CART_SELECT_LOCATION_POPUP) && (
								<SelectLocation
									currentPosition={location.currentLocation}
									locations={currentFilteredRestaurantList}
									orderingType={orderingMode.orderingType}
									isShowLocationPermissionRequest={isPossibleToRequestLocationPermission(permission.location.status)}
									onLocationPermissionRequestClick={openLocationPermissionConfirmation}
									onLocationClick={setCurrentRestaurantFromCart}
									onOverlayClick={cancelSelectLocationFromCart}
								/>
							)}
							{
								popup.includes(CART_ZIP_EDIT_POPUP) && (
									<ZipEdit
										error={fetchError[RESTAURANT_LIST_BY_ZIP]}
										onOverlayClick={cancelZipEditFromCart}
										onCancelClick={cancelZipEditFromCart}
										onDoneClick={doneZipEditFromCart}
									/>
								)
							}
							{
								popup.includes(CART_DELIVERY_ADDRESS_POPUP) && (
									<DeliveryAddress
										isRequestInProgress={fetchProgress[RESTAURANT_LIST_BY_ZIP]}
										defaultAddressValue={currentDeliveryAddress?.address}
										defaultPredictionIdValue={currentDeliveryAddress?.predictionId}
										defaultZipValue={currentDeliveryAddress?.zip}
										error={fetchError[RESTAURANT_LIST_BY_ZIP]}
										onOverlayClick={() => cancelDeliveryAddressFromCart()}
										onCancelClick={() => cancelDeliveryAddressFromCart()}
										onDoneClick={(address, zip, location, predictionId, isCheckDeliveryAddress) => doneDeliveryAddressFromCart(address, zip, location, predictionId, isCheckDeliveryAddress)}
									/>)
							}
							{
								popup.includes(PROMOCODE_EDIT_POPUP) && (
									<PromocodeEdit
										error={fetchError[APPLY_PROMOCODE]}
										onOverlayClick={() => cancelPromocode()}
										onCancelClick={() => cancelPromocode()}
										onDoneClick={promocode => donePromocode(promocode)}
									/>)
							}
							{
								popup.includes(MOBILE_PAY_FORM_POPUP) && (
									<MobilePayForm
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										mobilePayRedirectAction={payment.mobilePayRedirectAction}
										onMobilePaySubmit={() => mobilePaySubmit(currentRestaurantId)}
										onMobilePayRedirect={() => {
											mobilePayRedirect(currentTemporaryOrderId, currentRestaurantId)
										}}
									/>
								)
							}
							{
								popup.includes(STRIPE_CARD_REGISTRATION_POPUP) && (
									<StripeCardRegistration
										stripeKey={payment.stripeKey}
										stripeClientSecret={payment.stripeClientSecret}
										onCancelClick={cancelStripeCardRegistration}
										onOverlayClick={cancelStripeCardRegistration}
										onRegistrationSuccess={() => stripeSuccess(currentRestaurantId, currentTemporaryOrderId)}
										onRegistrationError={() => stripeError(currentRestaurantId)}

									/>
								)
							}
							{
								popup.includes(STRIPE_THREE_DS_POPUP) && (
									<StripeThreeDs
										redirectUrl={payment.redirectUrl}
										onOverlayClick={cancelStripeThreeDs}
										on3DSSuccessful={() => stripeSuccess(currentRestaurantId, currentTemporaryOrderId)}
									/>
								)
							}
							{
								popup.includes(ADYEN_CARD_REGISTRATION_POPUP) && (
									<AdyenCardRegistration
										currentCardNumber={currentCustomer?.cardNumber}
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										handleAction={payment.adyenHandleAction}
										onOverlayClick={() => cancelAdyenCardRegistration()}
										onCancelClick={() => cancelAdyenCardRegistration()}
										onSubmit={(state, dropin) => submitAdyenCardRegister(state.data)}
										onAdditionalDetails={(state, dropin) => submitAdyenCardAdditionalDetails(state.data)}
									/>
								)
							}
							{
								popup.includes(SWISH_PAY_POPUP) && (
									<SwishPay
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										handleAction={payment.adyenHandleAction}
										onOverlayClick={() => cancelSwishPay()}
										onCancelClick={() => cancelSwishPay()}
										onSubmit={(state, dropin) => initSwishPayment(state.data)}
										onAdditionalDetails={(state, dropin) => submitSwishPaymentAdditionalDetails(state.data)}
									/>
								)
							}
							{
								popup.includes(VIPPS_PAYMENT_FRAME_POPUP) && (
									<VippsPaymentFrame
										url={payment.redirectUrl}
										onPaymentSuccess={() => vippsSuccess(currentRestaurantId, currentTemporaryOrderId)}
										onPaymentError={message => vippsError(message, currentRestaurantId)}
										onOverlayClick={() => cancelVippsPaymentFrame()}
									/>
								)
							}
							{
								popup.includes(ADYEN_GOOGLE_PAY_POPUP) && (
									<AdyenGooglePay
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										orderAmount={payment.orderAmount}
										orderCurrency={payment.orderCurrency}
										handleAction={payment.adyenHandleAction}
										cancelGooglePayPopup={() => cancelGooglePayPopup()}
										onSubmit={(state, dropin) => initGooglePayPayment(state.data)}
										onAdditionalDetails={(state, dropin) => submitAdyenCardAdditionalDetails(state.data)}
									/>
								)
							}
							{
								popup.includes(ADYEN_APPLE_PAY_POPUP) && (
									<AdyenApplePay
										adyenClientKey={payment.adyenClientKey}
										adyenPaymentMethodsResponse={payment.adyenPaymentMethodsResponse}
										adyenCountryCode={payment.adyenCountryCode}
										orderAmount={payment.orderAmount}
										orderCurrency={payment.orderCurrency}
										cancelApplePayPopup={() => cancelApplePayPopup()}
										onSubmit={(state, dropin) => initApplePayPayment(state.data)}
									/>
								)
							}
							{
								popup.includes(TABLE_EDIT_POPUP) && (
									<TableEdit
										restaurantDeliveryLabel={currentRestaurant.deliveryLabel}
										defaultValue={currentTableNumber}
										error={fetchError[SET_TABLE]}
										onOverlayClick={() => cancelTableEdit()}
										onCancelClick={() => cancelTableEdit()}
										onDoneClick={tableNumber => doneTableEdit(tableNumber)}
									/>
								)
							}
							{
								fetchMessage[REPEAT_ORDER] && fetchMessage[REPEAT_ORDER].length > 0 && (<ErrorMessage
									description={fetchMessage[REPEAT_ORDER].join('')}
									onOverlayClick={cancelRepeatOrderMessageFromCart}
									control={<Button isAutoWidth
																	 onClick={cancelRepeatOrderMessageFromCart}>
										{getSafeTranslation('RepeatOrderMessage.buttonCaption', translations)}
									</Button>}
								/>)
							}
							{
								popup.includes(VIPPS_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('VippsErrorMessagePopup.title', translations)}
										description={fetchError[VIPPS_ERROR]}
										onOverlayClick={() => cancelVippsErrorMessage()}
										control={<Button isAutoWidth onClick={() => cancelVippsErrorMessage()}>
											{getSafeTranslation('VippsErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(DISCOUNT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('DiscountErrorMessagePopup.title', translations)}
										description={fetchError[DISCOUNT]}
										onOverlayClick={cancelDiscountErrorMessage}
										control={<Button isAutoWidth onClick={cancelDiscountErrorMessage}>
											{getSafeTranslation('DiscountErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(SEND_ORDER_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('SendOrderErrorMessagePopup.title', translations)}
										description={fetchError[SEND_ORDER]}
										onOverlayClick={cancelSendOrderErrorMessage}
										control={<Button isAutoWidth onClick={cancelSendOrderErrorMessage}>
											{getSafeTranslation('SendOrderErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								showServerPopup && currentServerPopups?.length > 0 && <ServerPopupContainer
									popups={currentServerPopups}
									onDoneClick={doneServer}
									onExternalLinkClick={openExternalLink}
									onMenuEntryLinkClick={(mainCategoryId, categoryId, menuEntryId) => {
										setShowServerPopup(false);
										openMenuEntryLink(mainCategoryId, categoryId, menuEntryId);
									}}
									onRestaurantLinkClick={openRestaurantLink}
									onOverlayClick={() => setShowServerPopup(false)}
									currentRestaurantId={currentRestaurantId}
								/>
							}
							{
								popup.includes(CART_MODIFIER_GROUP_EDIT_POPUP) && (
									<ModifierGroupEdit
										modifierGroup={editableCartModifierGroup}
										modifierGroupSelections={editableCartItem.modifierSelections[editableCartModifierGroupId]}
										modifierGroupIndex={editableCartItemMenuEntry.modIds?.indexOf(editableCartModifierGroupId)}
										modifierGroupsCount={editableCartItemMenuEntry.modIds?.length}
										title={editableCartItemMenuEntry.name}
										description={editableCartItemMenuEntry.desc}
										onCloseClick={closeCartModifierGroupEdit}
										onOverlayClick={closeCartModifierGroupEdit}
										onNextClick={
											editableCartItemMenuEntry.modIds?.indexOf(editableCartModifierGroupId) < editableCartItemMenuEntry.modIds?.length - 1
												? openNextCartModifierGroupEdit
												: closeCartModifierGroupEdit
										}
										onModifierChange={(newSelectedModifiers, modifierGroupId) => {
											changeOrderLineModifiers(
												currentRestaurantId,
												editableCartItemToken,
												modifierGroupId,
												newSelectedModifiers
											)
										}}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(MOBILE_PAY_INIT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('MobilePayInitErrorMessagePopup.title', translations)}
										description={fetchError[INIT_ADYEN_PAYMENT]}
										onOverlayClick={cancelMobilePayInitErrorMessage}
										control={<Button isAutoWidth onClick={cancelMobilePayInitErrorMessage}>
											{getSafeTranslation('MobilePayInitErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(ADYEN_CARD_PAYMENT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('AdyenCardCheckPaymentErrorMessagePopup.title', translations)}
										description={fetchError[CHECK_ADYEN_PAYMENT]}
										onOverlayClick={cancelAdyenCardCheckPaymentErrorMessagePopup}
										control={<Button
											isAutoWidth
											onClick={cancelAdyenCardCheckPaymentErrorMessagePopup}
										>
											{getSafeTranslation('AdyenCardCheckPaymentErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(SWISH_PAYMENT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('SwishPayCheckPaymentErrorMessagePopup.title', translations)}
										description={fetchError[CHECK_ADYEN_PAYMENT]}
										onOverlayClick={cancelSwishPayInitErrorMessage}
										control={<Button
											isAutoWidth
											onClick={cancelSwishPayInitErrorMessage}
										>
											{getSafeTranslation('SwishPayCheckPaymentErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(GOOGLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('GooglePayCheckPaymentErrorMessagePopup.title', translations)}
										description={fetchError[SUBMIT_GOOGLE_PAY]}
										onOverlayClick={cancelGooglePayInitErrorMessage}
										control={<Button
											isAutoWidth
											onClick={cancelGooglePayInitErrorMessage}
										>
											{getSafeTranslation('GooglePayCheckPaymentErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
							{
								popup.includes(APPLE_PAY_PAYMENT_ERROR_MESSAGE_POPUP) && (
									<ErrorMessage
										title={getSafeTranslation('ApplePayCheckPaymentErrorMessagePopup.title', translations)}
										description={fetchError[SUBMIT_APPLE_PAY]}
										onOverlayClick={cancelApplePayInitErrorMessage}
										control={<Button
											isAutoWidth
											onClick={cancelApplePayInitErrorMessage}
										>
											{getSafeTranslation('ApplePayCheckPaymentErrorMessagePopup.buttonCaption', translations)}
										</Button>}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								popup.includes(SLOW_SERVICE_POPUP) && (
									<ErrorMessage
										description={getSafeTranslation('SlowServicePopup.description', translations)}
										control={<Button
											onClick={doneSlowServiceCaption}
											isAutoWidth
										>
											{getSafeTranslation('SlowServicePopup.doneCaption', translations)}
										</Button>}
									/>
								)
							}
						</DialogStack>
						<DialogStack>
							{
								connectivity.isOnline === false && <Offline
								/>
							}
						</DialogStack>
					</DialogManager>
					{
						loading.isShowing && <LoadingSpinner style={loading.style}/>
					}
				</div>
			</Layout>
		</TranslationsContext.Provider>
	);
};

const mapStateToProps = state => {

	return {
		currentRestaurantId: getCurrentRestaurantIdSelector(state),
		cartItems: getCartItemsSelector(state),
		currentPurchase: getCurrentPurchaseSelector(state),
		currentRestaurant: getCurrentRestaurantSelector(state),
		orderingMode: state.orderingMode,
		orderTime: state.orderTime,
		translations: getTranslationsSelector(state),
		availablePaymentTypes: getAvailablePaymentTypesSelector(state),
		subPaymentTypes: getSubPaymentTypesSelector(state),
		currentPaymentType: getCurrentPaymentTypeSelector(state),
		currentSubPaymentType: getCurrentSubPaymentTypeSelector(state),
		currentServerValues: getCurrentServerValuesSelector(state),
		popup: state.popup,
		payment: state.payment,
		fetchProgress: state.fetchProgress,
		fetchError: state.fetchError,
		currentDeliveryAddress: getCurrentDeliveryAddressSelector(state),
		deliveryConditions: getDeliveryConditionsSelector(state),
		currentPromocode: getCurrentPromocodeSelector(state),
		currentTableNumber: getCurrentTableNumberSelector(state),
		currentMenu: getCurrentMenuSelector(state),
		currentCustomer: getCurrentCustomerSelector(state),
		connectivity: state.connectivity,
		isGiveTips: isGiveTipsSelector(state),
		tipAmount: getTipAmountSelector(state),
		currentServerPopups: getCurrentServerPopupsSelector(state),
		currentTemporaryOrderId: getCurrentTemporaryOrderIdSelector(state),
		currentFilteredRestaurantList: getCurrentFilteredRestaurantListSelector(state),
		permission: state.permission,
		fetchMessage: state.fetchMessage,
		loading: state.loading,
		currentServerConfig: getCurrentServerConfig(state),
		currentGuest: getCurrentGuestSelector(state),
	}
}

const mapDispatchToProps = dispatch => {
	return {
		incOrderLineQuantity: (restaurantId, token) => dispatch(incOrderLineQuantity(restaurantId, token)),
		decOrderLineQuantity: (restaurantId, token) => dispatch(decOrderLineQuantity(restaurantId, token)),
		setPickerDate: date => dispatch(setPickerDate(date)),
		setPickupDateTime: (date, time) => dispatch(setPickupDateTime(date, time)),
		setOrderComment: (restaurantId, comment) => dispatch(setOrderComment(restaurantId, comment)),
		setTipPercent: (restaurantId, percent) => dispatch(setTipPercent(restaurantId, percent)),
		setPaymentType: (restaurantId, paymentType, subPaymentType) => dispatch(setPaymentType(restaurantId, paymentType, subPaymentType)),
		setUseCashPoints: (restaurantId, useCashPoints) => dispatch(setUseCashPoints(restaurantId, useCashPoints)),
		placeOrder: (isGuestOrder, paymentType, currentCardNumber, isTableNotSelected, currentRestaurantId) => dispatch(
			placeOrder(isGuestOrder, paymentType, currentCardNumber, isTableNotSelected, currentRestaurantId)),
		cancelStripeCardRegistration: () => dispatch(cancelStripeCardRegistration()),
		stripeSuccess: (restaurantId, orderId) => dispatch(stripeSuccess(restaurantId, orderId)),
		stripeError: (restaurantId) => dispatch(stripeError(restaurantId)),
		openPromocode: () => dispatch(openPromocode()),
		cancelPromocode: () => dispatch(cancelPromocode()),
		donePromocode: promocode => dispatch(donePromocode(promocode)),
		openTableEdit: () => dispatch(openTableEdit()),
		cancelTableEdit: () => dispatch(cancelTableEdit()),
		doneTableEdit: tableNumber => dispatch(doneTableEdit(tableNumber)),
		cancelVippsPaymentFrame: () => dispatch(cancelVippsPaymentFrame()),
		vippsSuccess: (restaurantId, orderId) => dispatch(vippsSuccess(restaurantId, orderId)),
		vippsError: (message, restaurantId) => dispatch(vippsError(message, restaurantId)),
		cancelVippsErrorMessage: () => dispatch(cancelVippsErrorMessage()),
		cancelDiscountErrorMessage: () => dispatch(cancelDiscountErrorMessage()),
		openCartModifierGroupEdit: () => dispatch(openCartModifierGroupEdit()),
		cancelCartModifierGroupEdit: () => dispatch(cancelCartModifierGroupEdit()),
		changeOrderLineModifiers: (restaurantId, token, modifierGroupId, selectedModifierIds) => dispatch(
			changeOrderLineModifiers(restaurantId, token, modifierGroupId, selectedModifierIds)),
		cancelPickupWarningMessage: () => dispatch(cancelPickupWarningMessage()),
		donePickupWarningMessage: () => dispatch(donePickupWarningMessage()),
		cancelCardPaymentWarningMessage: (restaurantId) => dispatch(cancelCardPaymentWarningMessage(restaurantId)),
		doneCardPaymentWarningMessage: (restaurantId) => dispatch(doneCardPaymentWarningMessage(restaurantId)),
		incCutlery: (restaurantId) => dispatch(incCutlery(restaurantId)),
		decCutlery: (restaurantId) => dispatch(decCutlery(restaurantId)),
		cancelSendOrderErrorMessage: () => dispatch(cancelSendOrderErrorMessage()),
		cancelCustomPaymentTypeWarningMessage: () => dispatch(cancelCustomPaymentTypeWarningMessage()),
		doneCustomPaymentTypeWarningMessage: () => dispatch(doneCustomPaymentTypeWarningMessage()),
		doneServer: (popupId) => dispatch(doneServerPopup(popupId)),
		openExternalLink: (url) => dispatch(openExternalLink(url)),
		openRestaurantLink: (restaurantId) => dispatch(openRestaurantLink(restaurantId)),
		openMenuEntryLink: (mainCategoryId, categoryId, menuEntryId) => dispatch(openMenuEntryLink(mainCategoryId, categoryId, menuEntryId)),
		cancelZipEditFromCart: () => dispatch(cancelZipEditFromCart()),
		doneZipEditFromCart: zip => dispatch(doneZipEditFromCart(zip)),
		openLocationPermissionConfirmation: () => dispatch(openLocationPermissionConfirmation()),
		setCurrentRestaurantFromCart: restaurantId => dispatch(setCurrentRestaurantFromCart(restaurantId)),
		cancelSelectLocationFromCart: () => dispatch(cancelSelectLocationFromCart()),
		cancelRepeatOrderMessageFromCart: () => dispatch(cancelRepeatOrderMessageFromCart()),
		openDeliveryAddressFromCart: () => dispatch(openDeliveryAddressFromCart()),
		cancelDeliveryAddressFromCart: () => dispatch(cancelDeliveryAddressFromCart()),
		doneDeliveryAddressFromCart: (address, zip, location, predictionId, isCheckDeliveryAddress) => dispatch(
		  doneDeliveryAddressFromCart(address, zip, location, predictionId, isCheckDeliveryAddress)),
		mobilePaySubmit: (restaurantId) => dispatch(mobilePaySubmit(restaurantId)),
		mobilePayRedirect: (currentTemporaryOrderId, restaurantId) => dispatch(mobilePayRedirect(currentTemporaryOrderId, restaurantId)),
		cancelMobilePayInitErrorMessage: () => dispatch(cancelMobilePayInitErrorMessage()),
		submitAdyenCardRegister: (data) => dispatch(submitAdyenCardRegister(data)),
		submitAdyenCardAdditionalDetails: (data) => dispatch(submitAdyenCardAdditionalDetails(data, false)),
		cancelAdyenCardRegistration: () => dispatch(cancelAdyenCardRegistration()),
		cancelAdyenCardCheckPaymentErrorMessagePopup: () => dispatch(cancelAdyenCardCheckPaymentErrorMessagePopup()),
		initSwishPayment: (data) => dispatch(initSwishPayment(data)),
		submitSwishPaymentAdditionalDetails: (data) => dispatch(submitSwishPaymentAdditionalDetails(data)),
		cancelSwishPay: () => dispatch(cancelSwishPay()),
		cancelSwishPayInitErrorMessage: () => dispatch(cancelSwishPayInitErrorMessage()),
		doneSlowServiceCaption: () => dispatch(doneSlowServiceCaption()),
		cancelGooglePayPopup: () => dispatch(cancelGooglePayPopup()),
		initGooglePayPayment: (data) => dispatch(initGooglePayPayment(data)),
		cancelGooglePayInitErrorMessage: () => dispatch(cancelGooglePayInitErrorMessage()),
		cancelApplePayPopup: () => dispatch(cancelApplePayPopup()),
		cancelApplePayInitErrorMessage: () => dispatch(cancelApplePayInitErrorMessage()),
		initApplePayPayment: (data) => dispatch(initApplePayPayment(data)),
		cancelStripeThreeDs: () => dispatch(cancelStripeThreeDs()),
		vippsCheckPaymentPolling: (orderId) => dispatch(vippsCheckPaymentPolling(orderId)),
		openConfirmGuestOrderPopup: () => dispatch(openConfirmGuestOrderPopup()),
		cancelConfirmGuestOrderPopup: () => dispatch(cancelConfirmGuestOrderPopup()),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CartPage);
